import { gql } from 'apollo-angular';

const GET_ORGANIZATION_FOR_CONTEXT_NAME = gql`
  query getOrganizationForContextName($contextName: String) {
    organizations(criteria: { contextName: $contextName }) {
      id
      memberId
      name
      organizationType
    }
  }
`;

export default GET_ORGANIZATION_FOR_CONTEXT_NAME;
